import React from 'react'
import { connect } from 'react-redux'
import styles from './Participants.scss'
import { challengeMessages } from '../../intlMessages'
import { QuickStats } from 'features/experiences/QuickStats'
import { messages as lcMessages } from 'features/experiences/ShortcutQR/LimitedCodes'
import { Loadable } from 'common/Loadable'
import { ColWrap, MainCol } from 'common/layouts/SideNavLayout/TwoCol'
import { CTA } from 'common/styleguide/CTA'
import { SectionBox } from 'common/styleguide/SectionBox'
import { loginMessages } from 'common/styleguide/LoginModal'
import { GENERAL_MODAL } from 'common/modals/GeneralModal'
import { goalParticipantActions, goalParticipantSelectors } from 'data/resources/goalParticipants'
import { STATUS_REMOVED } from 'data/records/GoalParticipant'
import { useFormatMessage, commonActions } from 'lib/localization'
import { c } from 'lib/textUtils'
import { downloadFile } from 'lib/utils'
import { showModal } from 'lib/modalUtils'
import { defineMessages } from 'react-intl'
import moment from 'moment'

const messages = defineMessages({
  dateJoined: {
    id: 'ChallengeParticipants.dateJoined',
    defaultMessage: 'Date joined'
  }
})

export const _Participants = ({ goal, metaForGoal, participant, participants, removeParticipant, unremoveParticipant }) => {
  const fm = useFormatMessage()
  const onRemovedClicked = e => {
    const pId = parseInt(e.target.value, 10)
    const p = participant(pId)
    p.status === STATUS_REMOVED
      ? unremoveParticipant(pId)
      : removeParticipant(pId)
  }

  return (
    <ColWrap>
      <MainCol>
        <QuickStats className={styles.quickstats} totals={metaForGoal?.participants} />

        <SectionBox
          title={fm(challengeMessages.participants)}
          rightTitle={<CTA
            margins={false}
            grey
            autoWidth
            onClick={() => showModal(GENERAL_MODAL, {
              component: fm(challengeMessages.csvDisclaimer),
              confirmText: fm(challengeMessages.understand),
              onConfirm: () => downloadFile(`/goal_participants.csv?scope=participant&goal_id=${goal.id}`),
              showCancel: true
            })}
          >
            {fm(commonActions.exportCSV)}
          </CTA>}
          noPadding>
          <table className={styles.participantsTable}>
            <thead>
              <tr>
                <th>{fm(messages.dateJoined)}</th>
                <th>{fm(challengeMessages.firstName)}</th>
                <th>{fm(challengeMessages.lastName)}</th>
                <th>{c(fm(loginMessages.email).toLowerCase())}</th>
                <th>{fm(lcMessages.remove)}</th>
              </tr>
            </thead>
            <tbody>
              {participants.map(p => {
                return <tr key={p.id} className={p.status === STATUS_REMOVED && styles.strikethrough}>
                  <td>{moment(p.createdAt).format('MMM D, YYYY [at] h:mma')}</td>
                  <td>{p.userFirstName}</td>
                  <td>{p.userLastName}</td>
                  <td>{p.userEmail}</td>
                  <td>
                    <input type='checkbox' onChange={onRemovedClicked} value={p.id} checked={p.status === STATUS_REMOVED} />
                  </td>
                </tr>
              }).toIndexedSeq()}
            </tbody>
          </table>
        </SectionBox>
      </MainCol>
    </ColWrap>
  )
}

const LoadableParticipants = ({ loadAllParticipants, ...props }) => {
  const resourceLoaded = () => Promise.all([
    loadAllParticipants()
  ])

  return <Loadable
    component={_Participants}
    resourceLoaded={resourceLoaded}
    {...props}
  />
}

const mapStateToProps = (state, ownProps) => {
  return {
    participant: pId => goalParticipantSelectors.find(state, pId),
    participants: goalParticipantSelectors.byGoalId(state, ownProps.goal.id)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadAllParticipants: () => dispatch(goalParticipantActions.allParticipants({ goalId: ownProps.goal.id, scope: 'participants', perPage: 200 })),
    removeParticipant: pId => dispatch(goalParticipantActions.remove(pId)),
    unremoveParticipant: pId => dispatch(goalParticipantActions.unremove(pId))
  }
}

export const Participants = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableParticipants)
